import { Record } from 'immutable';

export const NotificationsFactory = new Record({
  approval_notification: {
    hours: 12,
    minutes: 0,
    timezone: '',
    notify_me: 'instantly',
    remind_me: false,
    frequency_days: 1,
  },
  chat_notification: {
    chat_to_mail: false,
  },
  slack_notification: {
    notify: false,
    connected: false,
  },
  // Bank Feed report opt-in (DA-19698). Defaults to OFF / not-connected so a
  // response without the group resolves deterministically and the section stays
  // hidden. `notify` is the user toggle; `connected` is backend-derived.
  bank_feed_notification: {
    notify: false,
    connected: false,
  },
});

export function notificationAdapter(d) {
  return NotificationsFactory(d);
}
